// extracted by css-extract-rspack-plugin
export default {"definitionSection":"pv48hPWzH3EkV9R_","definitionBox":"LNBP3XQkP3Q7DOi5","formRows":"Cg8lPDzXeiUEsiLN","definitionSentence":"vx9MJJZAToChZKS_"};